import { useEffect, useRef, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store";
import { setSignOut } from "../../store/modules/app";
import { LayoutConainer } from "./style";
import { useOutsideTouch } from "../../utils/Hooks";
import { Storage } from "../../utils/Storage";
import { isMobile } from "react-device-detect";

// type LayoutProps = {
//   children: React.ReactNode
// }


export default function Layout() {

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const location = useLocation()

  const user = useAppSelector(state => state.app.user)

  const [showMobileMenu, setShowMobileMenu] = useState(false)

  const menuRef = useRef<HTMLDivElement>(null)
  const [showDropdownMenu, setShowDropDownMenu] = useState(false)

  const isOutsideTouchMenu = useOutsideTouch(menuRef)

  useEffect(() => {
    let paths: string[] = []

    setShowDropDownMenu(false)

    if(user === undefined) return

    //if(location.pathname === '/') return

    // if(user !== null) {
    //   paths = ['/signup', '/signin']
    //   if(location.pathname === '/signup' ||
    //   location.pathname === '/signin') {
    //     navigate('/')
    //   }
    //   else {
    //     if(user.subscriptionList.find(v => v.deletedAt === null) && location.pathname === '/subscription') {
    //       navigate('/')
    //     }
    //   }
    // }
    // else {
    //   paths = ['/me', '/payment-history']
    //   if(location.pathname === '/me' ||
    //   location.pathname === '/payment-history') {
    //     navigate('/')
    //   }
    // }

    

    // for(let i = 0; paths.length; i++) {
    //   const path = paths[i]
    //   console.log(path)
    //   if(location.pathname === path) {
    //     navigate('/')
    //     break
    //   }
    // }
    
  }, [user, location])

  useEffect(() => {
    if(isOutsideTouchMenu) setShowDropDownMenu(false)
  }, [isOutsideTouchMenu])

  return (
    <LayoutConainer className="layout">
      <header>
        <div className="inner flex ai-c">
          <section className="logo">
            <Link to="/">
              <img src="/images/logo.png" alt="셀러가드" />
            </Link>
          </section>

          {isMobile && (
            <button
              className="mobile_menu"
              onClick={e => setShowMobileMenu(!showMobileMenu)}
            />
          )}

          <section className={`right flex${showMobileMenu ? ' show' : ''}`}>
            <div className="contact_btn_group flex">
              <button
                onClick={e => {
                  if(!isMobile) navigate('/advise')
                  else document.location.href = 'tel:010-8415-0997'

                  setShowMobileMenu(false)
                }}
              ><strong>구독상담 신청하기</strong></button>
              <button
                onClick={() => {
                  if(user === undefined) return
                  if(user === null) navigate('/signin')
                  else {
                    if(user.subscriptionList.find(v => v.deletedAt === null)) {
                      navigate('/apply')
                    }
                    else {
                      navigate('/subscription')
                    }
                  }
                  setShowMobileMenu(false)
                }}
              ><strong>법률자문 구독하기</strong></button>
              <button
                onClick={() => {
                  if(user === undefined) return
                  if(user === null) navigate('/signin')
                  else {
                    if(user.subscriptionList.find(v => v.deletedAt === null)) {
                      navigate('/apply')
                    }
                    else {
                      navigate('/subscription')
                    }
                  }
                  setShowMobileMenu(false)
                }}
              ><strong>법률자문 신청하기</strong></button>

            <button
              onClick={() => {
                navigate('/review')
                setShowMobileMenu(false)
              }}
            ><strong>리뷰 게시판</strong></button>

              {(user !== undefined && user !== null && user.subscriptionList.length !== 0 && user.subscriptionList[0].type === 2) && (
                <button
                  onClick={() => {
                    navigate('/addon')
                    setShowMobileMenu(false)
                  }}
                ><strong>추가자문료 결제하기</strong></button>
              )}
            </div>

            {(user !== undefined && user === null) && (
              <Link to="/signin" className="btn_signin"
                onClick={e => setShowMobileMenu(false)}
              ><strong>로그인</strong></Link>
            )}

            {(user !== undefined && user !== null) && (
              <div className="area_myinfo">
                <button className={`btn_id flex ai-c ${showDropdownMenu ? 'open' : ''}`}
                  onClick={e => setShowDropDownMenu(!showDropdownMenu)}
                >
                  <strong>{user.name}님</strong>
                  <div className="ic" />
                </button>

                {(showDropdownMenu || isMobile) && (
                  <div className="card" ref={menuRef}>
                    <Link to="me"
                      onClick={e => setShowMobileMenu(false)}
                    >내 정보</Link>
                    <Link to="payment-history"
                      onClick={e => setShowMobileMenu(false)}
                    >결제내역</Link>
                    <button
                      onClick={() => {
                        Storage.remove('token')
                        dispatch(setSignOut())
                      }}
                    >로그아웃</button>
                  </div>
                )}
              </div>
            )}
          </section>
        </div>
      </header>

      {user !== undefined && <Outlet />}

      <footer>
        <div className="inner">
          <section className="top flex">
            <div className="left logo" />

            <div className="right flex">
              <button
                onClick={() => window.open('./service.html', '_blank')}
              ><strong className="extra">이용약관</strong></button>
              <button
                onClick={() => window.open('./immunity.html', '_blank')}
              ><strong className="extra">면책공고</strong></button>
              <button
                onClick={() => window.open('./privacy.html', '_blank')}
              ><strong className="extra">개인정보 처리방침</strong></button>
            </div>
          </section>

          <section className="bottom">
            <p>법무법인(유한) 강남</p>
            <p>사업자등록번호 : 114-87-06003 | 대표자 : 구본민 외 4명</p>
            <span>주소 : 서울 서초구 서초중앙로 199, 4, 5층 (반포동)</span>
            <br />
            <span>이메일 : kalhi@naver.com</span>
            <span>전화 : 010-8415-0997 <br className="mobile" /> (평일 10:00 ~ 18:00)</span>
            <br className="web"/>
            <span>개인정보책임자 : 박종인</span>
            <br className="mobile" />
            <span>광고책임변호사 : 박종인</span>
            <br className="mobile" />

            <span>통신판매업신고 : 2020-서울서초-3754</span>

            <p className="fs12">© 2023 법무법인(유한) 강남. All Rights Reserved.</p>
          </section>
        </div>
      </footer>
    </LayoutConainer>
  )
}